var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 255,
    viewBox: "0 0 251 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_39_527)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.336 13.3286L166.773 65.4995L157.689 79.9846L154.252 27.8137L163.336 13.3286Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.572 52.2419C135.976 55.3108 133.766 58.0114 131.188 60.0982C128.488 62.3078 125.173 64.3947 121.245 66.4815C118.667 67.8318 115.721 68.9366 112.53 69.7959C109.215 70.6552 106.024 71.6372 102.955 72.3737C99.7631 73.3558 96.817 74.4606 94.1163 75.9336C92.5205 76.7929 91.0475 77.775 89.5744 79.248C88.1013 80.4756 87.6103 82.5624 87.9786 85.1403L93.1343 117.179C93.6253 121.23 93.7481 125.404 93.3798 129.823C93.0116 134.242 92.3978 138.17 91.4157 141.608C90.6792 135.838 89.6972 130.314 88.4696 124.913C87.2421 119.389 86.1373 113.988 85.278 108.464C84.2959 102.94 83.8049 97.293 83.6822 91.278C83.6822 86.7361 84.1732 82.4396 85.0325 78.266C85.8918 73.9695 87.1193 70.1641 88.7151 66.727C90.802 63.5354 93.6253 61.203 97.1852 59.6072C100.745 58.1341 104.673 56.7838 109.215 55.5563L117.808 53.3467C119.404 49.7868 120.754 47.0862 121.613 45.1221C122.473 43.158 123.209 41.685 123.823 40.7029C124.437 39.7209 124.928 38.9844 125.296 38.4933C125.664 38.0023 126.155 37.5113 126.769 37.0203C128.119 35.7927 130.084 35.3017 132.539 35.5472C134.994 35.67 137.326 35.9155 139.536 36.161C140.641 36.2838 141.377 36.7748 141.5 37.6341C141.745 38.4933 141.745 39.3526 141.623 40.2119C140.641 44.9994 139.29 49.0503 137.572 52.2419Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_n_39_527)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.075 10.3999L167.721 65.739L156.95 82.9138L153.304 27.5747L164.075 10.3999ZM154.252 27.814L157.689 79.985L166.773 65.4997L163.336 13.3287L154.252 27.814Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.165 36.3131C127.771 34.8672 130.018 34.3637 132.615 34.6202C135.089 34.745 137.436 34.9922 139.638 35.2369C140.292 35.3095 140.924 35.4992 141.433 35.8694C141.947 36.2435 142.298 36.7772 142.409 37.436C142.685 38.4377 142.676 39.4163 142.543 40.3435L142.539 40.3717L142.534 40.3989C141.541 45.2372 140.168 49.3771 138.396 52.671C136.743 55.8513 134.452 58.6523 131.773 60.8208C129.01 63.0813 125.64 65.2001 121.682 67.3029L121.677 67.3056C119.027 68.6933 116.015 69.8206 112.771 70.694L112.767 70.6953L112.763 70.6962C109.537 71.5327 106.252 72.5373 103.203 73.2704C100.052 74.2411 97.1791 75.3223 94.5615 76.7501L94.5574 76.7528C93.0185 77.5815 91.6248 78.513 90.2318 79.906L90.2023 79.9355L90.1696 79.9627C89.056 80.8908 88.5543 82.5712 88.8968 84.9926L94.0525 117.032L94.0552 117.05L94.0575 117.068L94.1465 117.84C94.5693 121.708 94.6568 125.695 94.3063 129.901C93.9351 134.355 93.314 138.348 92.3097 141.863L90.4934 141.726C89.7606 135.986 88.7836 130.491 87.5627 125.119L87.5618 125.115C86.3337 119.588 85.2255 114.172 84.3624 108.627C83.4324 103.396 82.9396 98.0628 82.7799 92.4282L82.7522 91.2971V91.2785L82.7581 90.4166C82.816 86.1252 83.3045 82.0475 84.1203 78.0837C84.9925 73.7231 86.2415 69.8465 87.8715 66.3357L87.9001 66.2748L87.9369 66.2185C90.1279 62.8676 93.094 60.4223 96.8047 58.7588L96.8169 58.7534L96.8297 58.7479C100.428 57.2588 104.395 55.8963 108.973 54.6589L108.978 54.6571L108.984 54.6558L117.145 52.557C117.876 50.9369 118.551 49.5003 119.146 48.2396C119.793 46.8685 120.339 45.7164 120.762 44.7495C121.627 42.7727 122.384 41.2505 123.034 40.2105C123.652 39.2219 124.16 38.4585 124.552 37.9355C124.974 37.3738 125.517 36.8343 126.165 36.3131ZM132.539 35.5475C130.084 35.302 128.119 35.793 126.769 37.0205C126.155 37.5115 125.664 38.0026 125.296 38.4936L125.152 38.6893C124.803 39.1726 124.36 39.8439 123.823 40.7031L123.587 41.0946C123.023 42.0612 122.365 43.4038 121.614 45.1223L121.269 45.8938C120.413 47.7751 119.204 50.2322 117.808 53.3471L109.215 55.5567C104.673 56.7842 100.745 58.1345 97.1852 59.6075C93.6254 61.2033 90.802 63.5355 88.7152 66.7271C87.1194 70.1642 85.8919 73.9698 85.0326 78.2663C84.1733 82.4399 83.6821 86.7365 83.6821 91.2785C83.8049 97.2934 84.2958 102.94 85.2778 108.464C86.1371 113.988 87.242 119.389 88.4695 124.913C89.6971 130.314 90.6791 135.838 91.4156 141.608C92.3363 138.385 92.9333 134.732 93.3078 130.646L93.38 129.823C93.7483 125.404 93.6254 121.23 93.1343 117.179L87.9787 85.1406C87.6104 82.5628 88.1014 80.476 89.5743 79.2484C90.9553 77.8674 92.3365 76.918 93.8186 76.0966L94.1165 75.9341C96.6483 74.5531 99.3957 73.4957 102.359 72.5598L102.955 72.3741C106.024 71.6375 109.215 70.6555 112.53 69.7962C115.721 68.937 118.667 67.8322 121.245 66.4819C125.173 64.3951 128.488 62.308 131.188 60.0984C133.686 58.0768 135.837 55.4792 137.42 52.5288L137.572 52.2423C139.29 49.0507 140.641 44.9997 141.623 40.2123C141.745 39.353 141.745 38.4937 141.5 37.6344C141.385 36.8288 140.73 36.3469 139.738 36.1886L139.536 36.1614C137.326 35.9159 134.994 35.6702 132.539 35.5475Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_n_39_527)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.468 112.094C149.872 114.427 148.277 116.636 146.681 118.723C146.435 119.091 146.19 119.214 145.944 119.337C145.576 119.46 145.208 118.969 144.839 118.109C143.612 115.04 142.262 113.199 140.789 112.34C139.438 111.481 137.965 111.481 136.615 112.217C135.142 112.954 133.669 114.181 132.196 115.777C130.845 117.373 129.495 119.214 128.268 121.178C127.04 123.142 125.935 124.984 125.076 126.579C124.094 128.175 123.357 129.403 122.866 130.139L122.744 124.738L122.866 124.615C123.971 122.528 125.567 119.705 127.654 116.145C129.741 112.585 132.073 109.025 134.651 105.588C136.369 103.256 138.088 101.292 139.929 99.696C141.771 97.9775 143.612 96.9954 145.453 96.6272C147.417 96.2589 149.381 97.1182 151.345 98.9595C152.205 99.8188 153.064 100.678 153.801 101.66C154.414 102.642 155.028 103.747 155.642 104.852C154.414 107.43 153.064 109.762 151.468 112.094Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.071 120.062C173.497 119.442 173.967 118.754 174.48 118.021C175.217 116.793 176.077 115.565 177.182 114.215C178.286 112.619 179.76 111.023 181.355 109.305C183.074 107.463 184.915 105.991 187.002 104.886C189.089 103.658 191.175 103.044 193.385 103.167C195.594 103.167 197.682 104.272 199.768 106.358C203.328 110.041 205.17 114.215 205.17 119.002C205.17 123.544 204.188 127.963 202.224 132.26C198.541 140.239 194.244 146.008 189.334 149.568C186.756 151.41 183.687 153.006 180.005 154.233C176.322 155.706 172.271 156.566 167.975 157.057C167.484 157.057 167.115 157.056 166.87 157.179C166.502 157.179 166.223 157.091 166.058 156.914L165.879 157.179L164.651 141.835C160.355 148.218 156.181 151.901 152.008 153.006C149.921 153.62 147.589 154.233 144.889 154.847C142.358 155.397 139.629 156.14 136.616 156.908C136.581 156.946 136.546 156.985 136.511 157.022H136.389C136.279 157.059 136.191 157.062 136.125 157.033C135.937 157.081 135.749 157.131 135.559 157.179L135.924 155.034C134.108 155.851 131.726 156.556 128.777 157.146C125.709 157.759 122.64 158.373 119.571 158.864C119.019 158.949 118.478 159.028 117.948 159.105C117.779 159.701 117.594 160.3 117.389 160.899C115.916 165.564 113.706 169.983 110.515 174.156C107.568 178.33 103.885 181.89 99.9569 184.959C95.7833 187.905 91.6095 189.746 87.1903 190.605C82.6486 191.465 78.1068 191.711 73.4423 191.588C68.655 191.342 64.113 190.974 59.5712 190.605C59.2029 190.483 58.9569 190.237 58.9569 189.869C58.957 189.378 59.0799 189.01 59.4482 188.888C65.8313 185.328 72.5827 182.136 79.8251 179.436C87.0676 176.735 94.1875 173.911 101.184 171.088C103.026 170.351 104.745 169.369 106.341 168.265C107.937 167.16 109.287 165.809 110.515 164.459C110.883 164.091 111.005 163.354 110.76 162.372C110.391 161.267 110.023 160.531 109.655 159.917C107.691 160.285 105.604 160.408 103.394 160.162C101.062 160.039 99.466 159.303 98.3612 158.198C97.5021 157.094 97.011 155.989 97.1337 154.516C97.2565 153.288 97.5024 151.937 98.1161 150.71C99.4663 148.01 100.816 145.309 101.921 142.486C103.148 139.663 104.745 137.208 106.709 134.998C107.568 133.893 108.795 133.648 110.268 134.139C111.619 134.63 112.723 135.243 113.46 135.979C115.775 138.295 117.379 140.933 118.273 143.895C118.297 143.892 118.32 143.89 118.344 143.888C120.799 143.642 123.376 143.274 126.322 142.906C129.268 142.538 132.092 142.047 134.793 141.556C137.616 140.942 139.825 140.328 141.421 139.592C143.017 138.978 144.245 137.996 145.35 136.646C146.332 135.418 147.068 134.313 147.436 133.208C147.805 132.595 147.927 132.595 148.05 133.454C148.172 134.19 148.05 134.68 147.928 134.804C147.427 136.305 146.843 138.134 146.112 140.155C155.067 138.663 161.064 137.096 164.161 135.451L161.46 98.0108L170.544 83.0352L173.071 120.062ZM187.247 121.58C182.075 118.707 177.441 120.03 173.446 125.55L174.526 141.363C178.194 140.987 181.647 140.4 184.792 139.502C188.474 138.765 191.789 137.538 194.98 136.065C195.349 129.437 192.771 124.649 187.247 121.58ZM233.894 65.2354C234.999 64.6218 235.367 64.8674 235.244 66.0947L231.193 80.457C226.774 83.0348 222.6 85.4907 218.427 87.7002C214.499 90.0324 210.448 92.242 206.397 94.5742C202.347 96.9065 198.173 99.3617 193.631 101.939C192.526 102.553 192.035 102.308 192.28 101.08L196.331 86.8408C200.873 84.2631 205.047 81.8079 209.098 79.4756C213.148 77.1433 217.077 74.9329 221.128 72.6006C225.179 70.2683 229.353 67.8131 233.894 65.2354Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2195 146.169C67.6236 149.238 65.4141 151.938 62.8362 154.025C60.1356 156.235 56.8212 158.321 52.893 160.408C50.3152 161.759 47.3691 162.863 44.1774 163.723C40.863 164.582 37.6714 165.564 34.6025 166.3C31.4109 167.283 28.4648 168.387 25.7642 169.86C24.1684 170.72 22.6953 171.702 21.2222 173.175C19.7492 174.402 19.2582 176.489 19.6264 179.067L24.7821 211.106C25.2732 215.157 25.3959 219.331 25.0276 223.75C24.6594 228.169 24.0456 232.097 23.0636 235.534C22.327 229.765 21.345 224.241 20.1174 218.84C18.8899 213.316 17.7851 207.914 16.9258 202.39C15.9438 196.866 15.4527 191.22 15.33 185.205C15.33 180.663 15.821 176.366 16.6803 172.193C17.5396 167.896 18.7671 164.091 20.363 160.654C22.4498 157.462 25.2732 155.13 28.833 153.534C32.3929 152.061 36.3211 150.711 40.863 149.483L49.4559 147.273C51.0517 143.714 52.402 141.013 53.2613 139.049C54.1206 137.085 54.8571 135.612 55.4709 134.63C56.0847 133.648 56.5757 132.911 56.944 132.42C57.3122 131.929 57.8032 131.438 58.417 130.947C59.7673 129.719 61.7314 129.228 64.1865 129.474C66.6416 129.597 68.974 129.842 71.1835 130.088C72.2883 130.211 73.0249 130.702 73.1476 131.561C73.3931 132.42 73.3931 133.279 73.2704 134.139C72.2883 138.926 70.938 142.977 69.2195 146.169Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_n_39_527)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.17 119.002C205.17 114.215 203.328 110.041 199.769 106.359C197.682 104.272 195.595 103.167 193.385 103.167C191.176 103.044 189.089 103.658 187.002 104.885C184.915 105.99 183.074 107.463 181.355 109.305C179.759 111.023 178.286 112.619 177.182 114.215C176.077 115.565 175.218 116.793 174.481 118.02C173.968 118.754 173.497 119.442 173.072 120.062L172.97 118.568C173.2 118.234 173.442 117.883 173.7 117.514C174.452 116.264 175.326 115.017 176.437 113.656C177.585 112.005 179.098 110.369 180.674 108.672L180.675 108.67C182.447 106.772 184.363 105.234 186.547 104.074C188.124 103.149 189.732 102.538 191.407 102.315C191.361 102.195 191.331 102.074 191.314 101.961C191.261 101.621 191.297 101.253 191.368 100.898L191.376 100.861L191.386 100.826L195.541 86.2195L195.872 86.0315C200.412 83.4547 204.572 81.0078 208.634 78.669C210.661 77.5015 212.658 76.3651 214.653 75.2298C216.648 74.0942 218.641 72.9599 220.664 71.7951C224.703 69.4692 228.891 67.0055 233.435 64.4267L233.439 64.4249L233.443 64.4226C233.748 64.2529 234.066 64.1059 234.376 64.033C234.681 63.9615 235.123 63.9293 235.533 64.1924C235.945 64.4577 236.098 64.877 236.155 65.1868C236.213 65.4998 236.204 65.8466 236.17 66.1871L236.162 66.2684L231.987 81.0711L231.662 81.2604C227.256 83.8308 223.069 86.2932 218.881 88.5112C214.957 90.8401 210.875 93.0689 206.861 95.3797C203.022 97.5901 199.048 99.924 194.763 102.364C196.7 102.723 198.501 103.83 200.221 105.499L200.426 105.701L200.437 105.712C204.143 109.546 206.1 113.944 206.1 119.002L206.097 119.441C206.035 123.967 205.024 128.371 203.069 132.646L203.068 132.649C199.347 140.712 194.964 146.635 189.88 150.321L189.875 150.325C187.224 152.219 184.078 153.853 180.322 155.107C176.546 156.613 172.419 157.484 168.08 157.98L168.028 157.986H167.975C167.718 157.986 167.545 157.987 167.408 157.998C167.291 158.008 167.261 158.022 167.273 158.017L167.09 158.109H166.87C166.461 158.109 165.992 158.031 165.602 157.747C165.166 157.43 164.958 156.951 164.958 156.443V156.22L165.688 154.783L165.879 157.179L166.059 156.914C166.207 157.072 166.446 157.16 166.758 157.176L166.87 157.179C167.054 157.087 167.307 157.064 167.629 157.058L167.975 157.056C172.271 156.565 176.322 155.706 180.005 154.233C183.688 153.005 186.756 151.409 189.334 149.568C194.091 146.12 198.272 140.597 201.876 133.001L202.223 132.26C204.126 128.098 205.107 123.82 205.167 119.427L205.17 119.002ZM173.447 125.55C177.442 120.03 182.075 118.707 187.247 121.58C192.771 124.649 195.349 129.436 194.981 136.065C191.79 137.538 188.475 138.766 184.792 139.503C181.647 140.401 178.194 140.99 174.526 141.366L174.463 140.437C178.081 140.065 181.467 139.485 184.537 138.608L184.573 138.598L184.61 138.59C188.005 137.911 191.09 136.802 194.076 135.455C194.163 132.519 193.626 130.024 192.504 127.927C191.349 125.769 189.545 123.971 187.04 122.531L186.796 122.393C184.211 120.957 181.881 120.693 179.746 121.445C177.622 122.193 175.538 124.001 173.548 127.043L173.447 125.55ZM235.245 66.095C235.367 64.8674 234.999 64.6216 233.894 65.2354C229.352 67.8132 225.179 70.2683 221.128 72.6006C217.077 74.933 213.149 77.1426 209.098 79.475C205.047 81.8073 200.873 84.2624 196.331 86.8402L192.28 101.08C192.035 102.307 192.526 102.553 193.631 101.939C197.037 100.006 200.236 98.1417 203.332 96.3464L206.397 94.5742C210.448 92.2418 214.499 90.0321 218.427 87.6998C222.601 85.4902 226.775 83.035 231.194 80.4572L235.245 66.095Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.879 157.179L166.059 156.914C166.224 157.09 166.503 157.179 166.87 157.179C166.923 157.153 166.982 157.133 167.046 157.117L165.163 159.888L163.93 144.47C160.096 149.648 156.247 152.838 152.264 153.899C150.159 154.518 147.81 155.136 145.094 155.754L145.086 155.755C142.28 156.365 139.259 157.213 135.785 158.081L134.403 158.427L134.909 155.457C135.265 155.32 135.604 155.179 135.924 155.035L135.559 157.179C135.75 157.131 135.939 157.082 136.128 157.035C136.194 157.062 136.28 157.059 136.389 157.023H136.511C136.546 156.986 136.579 156.948 136.614 156.911C139.418 156.197 141.975 155.501 144.356 154.964L144.889 154.847C147.589 154.233 149.921 153.619 152.008 153.005C156.182 151.901 160.356 148.218 164.652 141.835L165.879 157.179ZM175.452 141.266C175.145 141.301 174.836 141.334 174.526 141.366L173.447 125.55C173.729 125.16 174.015 124.791 174.303 124.443L175.452 141.266ZM140.007 140.158C139.232 140.432 138.358 140.691 137.384 140.944L137.457 140.515L138.133 140.422C138.768 140.335 139.393 140.246 140.007 140.158ZM171.272 80.042L173.919 118.828C173.62 119.263 173.337 119.676 173.072 120.062L170.544 83.0349L161.46 98.011L164.161 135.451L163.779 135.647C160.584 137.221 154.712 138.724 146.112 140.158C146.235 139.818 146.353 139.483 146.468 139.155C149.519 138.639 152.211 138.115 154.548 137.583C158.451 136.694 161.31 135.793 163.189 134.898L160.511 97.7821L171.272 80.042Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.14 160.82C110.169 160.881 110.199 160.944 110.228 161.008L110.107 161.021L110.14 160.82ZM135.559 157.179C135.75 157.131 135.939 157.082 136.128 157.034C136.194 157.062 136.28 157.058 136.389 157.022H136.511L136.614 156.911C137.164 156.771 137.704 156.632 138.235 156.495C137.896 156.89 137.548 157.279 137.187 157.661L136.912 157.952H136.506C136.346 157.986 136.147 158.001 135.933 157.947C135.584 157.86 135.329 157.627 135.188 157.346C135.067 157.103 135.044 156.856 135.044 156.677C135.044 156.584 135.051 156.488 135.062 156.393C133.369 157.03 131.332 157.583 128.96 158.057C125.894 158.67 122.807 159.288 119.718 159.782L119.712 159.783C119.008 159.891 118.321 159.993 117.654 160.089C117.757 159.761 117.855 159.434 117.948 159.107C118.095 159.085 118.243 159.064 118.392 159.042L119.571 158.864C122.64 158.373 125.709 157.759 128.778 157.145C131.727 156.555 134.109 155.851 135.924 155.034L135.559 157.179ZM147.316 131.972C147.494 131.875 147.791 131.784 148.129 131.896C148.438 131.999 148.608 132.217 148.686 132.34C148.767 132.469 148.814 132.599 148.843 132.691C148.899 132.871 148.936 133.086 148.968 133.301C149.042 133.749 149.047 134.149 149.003 134.482C148.98 134.647 148.944 134.809 148.891 134.958C148.865 135.03 148.827 135.123 148.769 135.221C148.322 136.565 147.801 138.189 147.165 139.979C146.818 140.038 146.468 140.098 146.112 140.157C146.843 138.135 147.426 136.306 147.927 134.804C148.05 134.681 148.173 134.19 148.05 133.453C147.928 132.594 147.805 132.594 147.436 133.208C147.068 134.313 146.331 135.417 145.349 136.645C144.245 137.995 143.017 138.977 141.422 139.591C139.826 140.328 137.616 140.942 134.793 141.555C132.092 142.046 129.269 142.537 126.322 142.905C123.376 143.274 120.798 143.642 118.343 143.888C118.32 143.89 118.297 143.892 118.274 143.895C118.182 143.591 118.082 143.29 117.975 142.992C118.063 142.983 118.151 142.973 118.241 142.964L118.246 142.963L118.251 142.962C120.691 142.718 123.238 142.354 126.207 141.983C129.117 141.619 131.912 141.133 134.601 140.645C137.412 140.033 139.535 139.438 141.032 138.747L141.059 138.734L141.087 138.723C142.504 138.178 143.606 137.307 144.63 136.056C145.593 134.852 146.241 133.854 146.554 132.914L146.586 132.817L146.639 132.729C146.733 132.574 146.848 132.391 146.977 132.246C147.041 132.175 147.153 132.061 147.316 131.972Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.282 95.7136C147.588 95.2812 149.774 96.278 151.787 98.1021L151.981 98.2814L151.992 98.2914L152.003 98.3023C152.802 99.1007 153.648 99.946 154.396 100.908L154.545 101.103L154.568 101.134L154.589 101.168C155.061 101.922 155.531 102.745 155.994 103.573L156.455 104.401L156.687 104.819L156.481 105.252C155.232 107.875 153.858 110.249 152.236 112.62C150.634 114.96 149.032 117.178 147.429 119.276C147.052 119.823 146.639 120.03 146.36 120.169L146.301 120.199L146.238 120.22C145.497 120.466 144.943 119.997 144.686 119.697C144.407 119.372 144.179 118.929 143.984 118.476L143.98 118.465L143.976 118.455C142.811 115.542 141.6 113.946 140.433 113.212L140.32 113.144L140.305 113.134L140.289 113.124C139.239 112.456 138.128 112.451 137.06 113.034L137.046 113.042L137.031 113.049C135.701 113.714 134.321 114.848 132.894 116.391C131.577 117.949 130.257 119.75 129.056 121.671C127.832 123.629 126.74 125.451 125.895 127.021L125.882 127.044L125.868 127.067C124.898 128.644 124.144 129.9 123.64 130.655L122.004 133.11L121.805 124.362L122.112 124.055C123.223 121.964 124.803 119.169 126.851 115.675C128.953 112.09 131.303 108.503 133.902 105.037C135.647 102.669 137.411 100.648 139.32 98.9934C141.251 97.1976 143.235 96.1226 145.271 95.7154L145.282 95.7136ZM151.346 98.9598C149.382 97.1186 147.417 96.2595 145.453 96.6276C143.612 96.9959 141.77 97.9778 139.929 99.6963C138.088 101.292 136.369 103.256 134.651 105.589C132.073 109.026 129.741 112.586 127.654 116.146L126.894 117.446C125.176 120.4 123.833 122.79 122.866 124.616L122.743 124.739L122.866 130.139C123.357 129.403 124.094 128.176 125.076 126.58C125.828 125.184 126.768 123.599 127.813 121.909L128.267 121.179C129.495 119.215 130.845 117.373 132.196 115.777C133.669 114.181 135.142 112.954 136.615 112.217C137.965 111.481 139.438 111.481 140.789 112.34C142.262 113.2 143.612 115.041 144.839 118.109C145.185 118.915 145.53 119.397 145.875 119.353L145.944 119.337C146.19 119.215 146.435 119.092 146.681 118.723C148.077 116.897 149.473 114.977 150.87 112.963L151.468 112.095C153.064 109.762 154.414 107.43 155.642 104.852C155.028 103.747 154.414 102.642 153.8 101.66C153.064 100.678 152.205 99.819 151.346 98.9598Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.955 158.957C118.754 159.702 118.525 160.45 118.268 161.2C116.766 165.95 114.512 170.456 111.261 174.71C108.251 178.97 104.503 182.588 100.53 185.692L100.512 185.706L100.493 185.719C96.2259 188.731 91.9317 190.632 87.368 191.519L87.3635 191.52C83.03 192.34 78.707 192.608 74.2999 192.536L73.4177 192.517H73.4058L73.3945 192.517C69.7919 192.332 66.3288 192.078 62.907 191.807L59.3833 191.524L59.2766 191.488C58.6741 191.287 58.027 190.772 58.027 189.869C58.027 189.563 58.0624 189.197 58.2177 188.855C58.3766 188.506 58.6532 188.205 59.0555 188.042C65.4584 184.474 72.233 181.274 79.5006 178.564C86.7317 175.868 93.8426 173.048 100.837 170.226L100.839 170.224C102.602 169.519 104.259 168.574 105.811 167.5C107.321 166.454 108.616 165.165 109.826 163.833L109.841 163.817L109.856 163.802C109.857 163.801 109.86 163.798 109.866 163.789C109.872 163.78 109.881 163.765 109.89 163.744C109.909 163.699 109.932 163.629 109.945 163.526C109.972 163.321 109.959 163.022 109.865 162.63C109.628 161.926 109.394 161.39 109.163 160.945C107.32 161.236 105.372 161.315 103.321 161.089C100.895 160.957 99.1106 160.198 97.8269 158.976L97.7038 158.856L97.663 158.815L97.6271 158.77C96.6733 157.543 96.0593 156.213 96.2072 154.438L96.2076 154.431L96.2085 154.423C96.3358 153.151 96.596 151.67 97.2838 150.294C98.6372 147.588 99.9681 144.924 101.055 142.147L101.061 142.131L101.068 142.115C102.334 139.204 103.98 136.67 106.002 134.392C106.547 133.706 107.238 133.251 108.049 133.063C108.808 132.888 109.607 132.962 110.403 133.206L110.563 133.256L110.586 133.265C111.912 133.747 113.09 134.368 113.95 135.161L114.118 135.322C116.585 137.79 118.286 140.618 119.214 143.797C118.922 143.829 118.632 143.859 118.343 143.888C118.32 143.891 118.297 143.893 118.274 143.896C117.418 141.062 115.912 138.523 113.755 136.281L113.46 135.98C112.724 135.243 111.619 134.63 110.268 134.139C108.795 133.648 107.568 133.893 106.709 134.998C104.745 137.207 103.149 139.663 101.921 142.486C100.817 145.309 99.466 148.01 98.1157 150.71C97.5019 151.938 97.2567 153.289 97.134 154.516C97.0113 155.989 97.5021 157.094 98.3614 158.199C99.4661 159.303 101.062 160.04 103.394 160.163C105.604 160.408 107.691 160.285 109.655 159.917C110.023 160.531 110.391 161.267 110.76 162.372C111.005 163.354 110.882 164.091 110.514 164.459C109.286 165.809 107.936 167.16 106.341 168.264L106.04 168.47C104.529 169.491 102.911 170.397 101.185 171.088C94.1878 173.911 87.0678 176.735 79.8252 179.435L79.1477 179.69C72.1611 182.335 65.6316 185.439 59.4478 188.887C59.0797 189.01 58.9569 189.378 58.9569 189.869C58.9569 190.237 59.2026 190.483 59.5708 190.606C64.1127 190.974 68.6548 191.342 73.4422 191.588C78.1068 191.711 82.6486 191.465 87.1905 190.606C91.4716 189.773 95.5225 188.019 99.566 185.232L99.957 184.959C103.885 181.89 107.568 178.33 110.514 174.157C113.706 169.983 115.915 165.564 117.388 160.899C117.593 160.3 117.779 159.702 117.948 159.107C118.279 159.059 118.615 159.009 118.955 158.957Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_39_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8163 130.237C59.4215 128.793 61.6678 128.29 64.2624 128.546C66.737 128.671 69.0836 128.918 71.2862 129.163C71.94 129.235 72.5716 129.425 73.0807 129.795C73.595 130.169 73.9455 130.703 74.057 131.362C74.3326 132.363 74.3234 133.342 74.191 134.269L74.1869 134.297L74.1814 134.325C73.1889 139.163 71.8158 143.303 70.0443 146.597C68.3905 149.777 66.0998 152.578 63.421 154.747C60.6576 157.007 57.2876 159.126 53.3295 161.229L53.3245 161.231C50.6752 162.619 47.6631 163.746 44.419 164.62L44.4149 164.621L44.4108 164.622C41.1844 165.458 37.8997 166.463 34.851 167.196C31.6996 168.167 28.8269 169.248 26.2093 170.676L26.2053 170.679C24.6663 171.507 23.2727 172.439 21.8797 173.832L21.8501 173.861L21.8175 173.888C20.7038 174.817 20.2021 176.497 20.5447 178.918L25.7003 210.958L25.703 210.975L25.7053 210.993L25.7943 211.765C26.2171 215.634 26.3046 219.621 25.9541 223.826C25.5829 228.281 24.9618 232.274 23.9575 235.789L22.1412 235.652C21.4084 229.911 20.4314 224.417 19.2106 219.045L19.2097 219.041C17.9815 213.514 16.8734 208.098 16.0102 202.552C15.0802 197.322 14.5875 191.989 14.4277 186.354L14.4 185.223V185.204L14.4059 184.342C14.4638 180.051 14.9524 175.973 15.7682 172.009C16.6403 167.649 17.8893 163.772 19.5193 160.261L19.5479 160.201L19.5847 160.144C21.7757 156.793 24.7419 154.348 28.4525 152.685L28.4648 152.679L28.4775 152.674C32.0762 151.185 36.0424 149.822 40.6206 148.585L40.626 148.583L40.6315 148.582L48.7927 146.483C49.5237 144.863 50.1989 143.426 50.7939 142.165C51.4409 140.794 51.9865 139.642 52.4095 138.675C53.2744 136.698 54.0322 135.176 54.6822 134.136C55.3 133.148 55.8079 132.384 56.2002 131.861C56.6221 131.299 57.1664 130.759 57.8163 130.237ZM64.1866 129.473C61.7315 129.228 59.7673 129.719 58.417 130.946C57.8032 131.437 57.3122 131.928 56.944 132.419L56.8 132.615C56.451 133.098 56.0079 133.77 55.4709 134.629L55.2348 135.02C54.6709 135.987 54.0132 137.33 53.2613 139.048L52.9167 139.82C52.0608 141.701 50.852 144.158 49.4557 147.273L40.8631 149.482C36.3211 150.71 32.3929 152.06 28.833 153.533C25.2732 155.129 22.4498 157.461 20.363 160.653C18.7672 164.09 17.5397 167.896 16.6804 172.192C15.8211 176.366 15.33 180.662 15.33 185.204C15.4527 191.219 15.9436 196.866 16.9256 202.39C17.7849 207.914 18.8898 213.315 20.1174 218.839C21.3449 224.24 22.3269 229.764 23.0635 235.533C23.9841 232.311 24.5812 228.657 24.9556 224.572L25.0278 223.749C25.3961 219.33 25.2732 215.156 24.7822 211.105L19.6265 179.066C19.2582 176.489 19.7492 174.402 21.2221 173.174C22.6032 171.793 23.9843 170.844 25.4665 170.022L25.7643 169.86C28.2961 168.479 31.0436 167.421 34.0069 166.486L34.6026 166.3C37.6715 165.563 40.8631 164.581 44.1774 163.722C47.1696 162.916 49.946 161.895 52.4054 160.658L52.8931 160.408C56.8213 158.321 60.1355 156.234 62.8361 154.024C65.3334 152.003 67.4851 149.405 69.068 146.455L69.2197 146.168C70.9382 142.976 72.2885 138.925 73.2705 134.138C73.3933 133.279 73.3929 132.419 73.1475 131.56C73.0324 130.755 72.3779 130.273 71.3861 130.114L71.1836 130.087C68.974 129.842 66.6417 129.596 64.1866 129.473Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_39_527",
    x: 83.6822,
    y: 13.3286,
    width: 83.0908,
    height: 128.279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 108
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_39_527"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_39_527",
    x: 139.852,
    y: 2.92861,
    width: 41.321,
    height: 95.4558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_39_527",
    x: 69.2822,
    y: 25.0858,
    width: 86.821,
    height: 134.922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_n_39_527",
    x: 82.7522,
    y: 10.3999,
    width: 84.9685,
    height: 131.464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 108
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_39_527"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_39_527",
    x: 138.904,
    y: -0.0000972748,
    width: 43.2167,
    height: 101.314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_39_527",
    x: 68.3522,
    y: 24.1562,
    width: 88.6806,
    height: 136.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_n_39_527",
    x: 15.33,
    y: 64.9121,
    width: 219.937,
    height: 170.623,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 108
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_39_527"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_39_527",
    x: 108.344,
    y: 86.1435,
    width: 61.6984,
    height: 62.3957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_39_527",
    x: 44.5569,
    y: 54.5121,
    width: 205.11,
    height: 155.506,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_39_527",
    x: 0.929995,
    y: 119.013,
    width: 86.821,
    height: 134.922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_n_39_527",
    x: 14.4,
    y: 63.9824,
    width: 221.797,
    height: 171.807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 108
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_39_527"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_39_527",
    x: 150.558,
    y: 53.5824,
    width: 100.039,
    height: 122.926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_39_527",
    x: 120.003,
    y: 69.642,
    width: 69.8487,
    height: 108.646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_39_527",
    x: 95.7071,
    y: 121.444,
    width: 67.7238,
    height: 57.9768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_39_527",
    x: 107.405,
    y: 85.2133,
    width: 63.6827,
    height: 66.2966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_39_527",
    x: 43.627,
    y: 122.567,
    width: 89.9868,
    height: 88.3801,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_39_527",
    x: 0.00000190735,
    y: 118.082,
    width: 88.6806,
    height: 136.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_527",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.796f181c92c4b694d4ff5241424c5a14.svg";
export { ForwardRef as ReactComponent };